import { styled } from '../../../../../modules';

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
`;

export const Input = styled.input<{ $accentColor: string }>`
    width: 16px;
    height: 16px;
    min-width: 16px;
    margin-top: 2px;
    accent-color: ${({ $accentColor }) => $accentColor};
    cursor: pointer;
`;

export const Label = styled.label<{ $accentColor: string }>`
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 1.5;
    color: ${({ $accentColor }) => $accentColor};
    cursor: pointer;

    a {
        font-weight: 500;
        text-decoration: none;
    }
`;

export const PseudoLink = styled.span<{ $color: string }>`
    color: ${({ $color }) => $color};
    font-weight: 500;
    cursor: pointer;
`;
